module.exports = __webpack_public_path__ + "media/andre3.054a6f19.mp3";